import {
  ServerItemInfo,
  ServerMachineAttachment,
  ServerMachineInfo,
  ServerPriceObject,
} from '@/api/type-server'
import { MachineType } from '@/consts/machine'
import { formatHwConfig, formatMachineName } from '@/utils/node'

export class Machine {
  agent_id?: number = 0
  domains: number[] = []
  unitSpec: ServerMachineInfo['unitSpec']
  maxAvailUnits: number = 0
  machineCategory: MachineType
  priceObject: ServerPriceObject
  originPriceObject: ServerPriceObject
  attachments: ServerMachineAttachment[] = []
  items: ServerItemInfo[] = []

  constructor(machineCategory: MachineType, props: ServerMachineInfo) {
    this.machineCategory = machineCategory
    this.unitSpec = props.unitSpec
    this.unitSpec.attributes.isMIG =
      (this.unitSpec.attributes.isMIG || this.unitSpec.gpuName?.includes('MIG')) ?? false
    this.unitSpec.attributes.isVGPU =
      (this.unitSpec.attributes.isVGPU || this.unitSpec.gpuName?.includes('MIG')) ?? false
    Object.assign(this, props)
    this.items = props.items ?? []
    let price = 0
    if (typeof props?.unitSpec?.discountPriceMillicent != 'undefined') {
      price = props?.unitSpec?.discountPriceMillicent / 1000
    } else {
      price = props?.unitSpec?.priceMillicent / 1000
    }
    const unit = 'hour'
    this.priceObject = {
      price,
      unit,
      text: `${price.toFixed(3)} Credit/${unit}`,
    }
    this.originPriceObject = {
      price: props?.unitSpec?.priceMillicent / 1000,
      unit,
      text: `${price.toFixed(3)} Credit/${unit}`,
    }
  }

  get hostType(): MachineType {
    return this.machineCategory
  }

  get displayTitle() {
    return formatMachineName(this.machineCategory, this.unitSpec)
  }

  get hwText() {
    const { cpuRamGB, diskGB, cpuCores, cpuName, gpuRamGB } = formatHwConfig(this.unitSpec)

    const textArr = [`${cpuCores}× ${cpuName}`, `${cpuRamGB}GB Ram`, `${diskGB}GB SSD`]

    if (this.hostType === MachineType.GPU) {
      textArr.splice(1, 0, `${gpuRamGB}GB VRAM`)
    }

    return textArr.join(' / ')
  }

  get unitStep() {
    return 1
  }

  get key(): string {
    const { cpuName, gpuName, classTag } = this.unitSpec
    return `${cpuName}-${gpuName}-${classTag}`
  }

  get hasDiscount(): boolean {
    return this.priceObject.price !== this.originPriceObject.price
  }

  static getMachineType(type: MachineType): MachineType {
    return type !== MachineType.CPU
      ? type !== MachineType.VGPU
        ? MachineType.GPU
        : MachineType.VGPU
      : MachineType.CPU
  }
}
